// toaster.component.ts
import { ChangeDetectorRef, Component, inject } from '@angular/core';

export type ToastType = 'success' | 'error' | 'info';

export interface Toast {
  id: number;
  message: string;
  type: ToastType;
}


@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.html',
  styleUrls: ['./toaster.scss']
})
export class Toaster {
  private cdr = inject(ChangeDetectorRef);

  toasts: { id: number; message: string; type: 'success' | 'error' | 'info' }[] = [];
  private id = 0;

  show(msg: string, type: 'success' | 'error' | 'info') {
    const toast = { id: ++this.id, message: msg, type };

    this.toasts = [...this.toasts, toast];
    this.cdr.detectChanges(); // ✅ render add

    setTimeout(() => {
      this.toasts = this.toasts.filter(t => t.id !== toast.id);
      this.cdr.detectChanges(); // ✅ render remove
    }, 5000);
  }

  clear() {
    this.toasts = [];
    this.cdr.detectChanges();
  }
}
